// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  stripeKey: 'pk_test_5HmJVJMZ717PAwkQeRARnhBh',
  firebase: {
    apiKey: 'AIzaSyCBjSd_L6Dy7X7ydcMkXxntM8w8aKM0_1M',
    authDomain: 'emp21charlitex.firebaseapp.com',
    databaseURL: 'https://emp21charlitex.firebaseio.com',
    projectId: 'emp21charlitex',
    storageBucket: '',
    messagingSenderId: '807701742146'
  }
};



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/environments/environment.ts